import { Payout } from 'store/api/payout';
import { Role, PayoutType, PayoutStatus } from 'types';
import { Flex, RemovePayoutDialog, ApprovalPayoutDialog } from 'components';
import {
  approveReimbursementRoles,
  canDeleteReimbursementStatuses,
} from 'config';

export interface GetRightSlotApprovalDialog {
  data?: Payout;
  type: PayoutType;
  authUserRole?: Role;
  withNavigate?: boolean;
  isCompanyOwner?: boolean;
}

export const getRightSlotApprovalDialog = ({
  data,
  type,
  authUserRole,
  isCompanyOwner,
  withNavigate = true,
}: GetRightSlotApprovalDialog) => {
  const canApproveReimbursement =
    isCompanyOwner ||
    (authUserRole && approveReimbursementRoles.includes(authUserRole));

  const isPending = data?.status === PayoutStatus.Pending;

  return data &&
    canDeleteReimbursementStatuses.includes(data?.status) &&
    canApproveReimbursement ? (
    <Flex gap={8}>
      {isPending && (
        <ApprovalPayoutDialog
          data={data}
          type={type}
          withNavigate={withNavigate}
        />
      )}
      <RemovePayoutDialog data={data} />
    </Flex>
  ) : undefined;
};
